import { Pipe, PipeTransform } from '@angular/core';

import { formatHiddenNumber } from '../utils/number.format';

@Pipe({
	name: 'copoHiddenNumber',
})
export class HiddenNumberPipe implements PipeTransform {
	transform(value: number, format: string) {
		return formatHiddenNumber(value, format);
	}
}
